import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({
  baseURL: API,
  withCredentials: true, // send cookies for auth
});

// Auth
export const authLogin = (email, password) =>
  client.post('/auth/login', { email, password }).then((r) => r.data);
export const changePassword = (current_password, new_password) =>
  client.post('/auth/change-password', { current_password, new_password }).then((r) => r.data);
export const authMe = () => client.get('/auth/me').then((r) => r.data);
export const authLogout = () => client.post('/auth/logout').then((r) => r.data);
export const updateMe = (data) => client.put('/auth/me', data).then((r) => r.data);

// Categories/config
export const getCategoriesConfig = () => client.get('/categories').then((r) => r.data);

// Boards
export const listBoards = () => client.get('/boards').then((r) => r.data);
export const createBoard = (data) => client.post('/boards', data).then((r) => r.data);
export const getBoard = (id) => client.get(`/boards/${id}`).then((r) => r.data);
export const updateBoard = (id, data) => client.put(`/boards/${id}`, data).then((r) => r.data);
export const deleteBoard = (id) => client.delete(`/boards/${id}`).then((r) => r.data);

// Cards
export const listCards = (boardId, startDate, endDate) =>
  client
    .get(`/boards/${boardId}/cards`, {
      params: { start_date: startDate, end_date: endDate },
    })
    .then((r) => r.data);
export const upsertCard = (boardId, data) =>
  client.put(`/boards/${boardId}/cards`, data).then((r) => r.data);

// Tasks (legacy - kept for BC)
export const listTasks = (params = {}) => client.get('/tasks', { params }).then((r) => r.data);
export const createTask = (data) => client.post('/tasks', data).then((r) => r.data);
export const updateTask = (id, data) => client.put(`/tasks/${id}`, data).then((r) => r.data);
export const deleteTask = (id) => client.delete(`/tasks/${id}`).then((r) => r.data);

// Issues (new - multiple per day/category)
export const listIssues = (boardId, params = {}) =>
  client.get(`/boards/${boardId}/issues`, { params }).then((r) => r.data);
export const createIssue = (boardId, data) =>
  client.post(`/boards/${boardId}/issues`, data).then((r) => r.data);
export const updateIssue = (id, data) => client.put(`/issues/${id}`, data).then((r) => r.data);
export const deleteIssue = (id) => client.delete(`/issues/${id}`).then((r) => r.data);
export const getIssue = (id) => client.get(`/issues/${id}`).then((r) => r.data);

// Team members
export const updateTeamMembers = (boardId, members) =>
  client.put(`/boards/${boardId}/team`, { team_members: members }).then((r) => r.data);

// Admin
export const listAllUsers = () => client.get('/admin/users').then((r) => r.data);
export const adminCreateUser = (data) => client.post('/admin/users', data).then((r) => r.data);
export const adminUpdateUser = (userId, data) =>
  client.put(`/admin/users/${userId}`, data).then((r) => r.data);
export const adminDeleteUser = (userId) =>
  client.delete(`/admin/users/${userId}`).then((r) => r.data);
export const bootstrapAdmin = () => client.post('/admin/bootstrap').then((r) => r.data);

// Analyses (generic templates)
export const listAnalyses = (params = {}) =>
  client.get('/analyses', { params }).then((r) => r.data);
export const createAnalysis = (data) => client.post('/analyses', data).then((r) => r.data);
export const updateAnalysis = (id, data) =>
  client.put(`/analyses/${id}`, data).then((r) => r.data);
export const deleteAnalysis = (id) => client.delete(`/analyses/${id}`).then((r) => r.data);

// Templates registry
export const listTemplates = () => client.get('/templates').then((r) => r.data);

// Analytics
export const getAnalytics = (boardId, params = {}) =>
  client.get(`/boards/${boardId}/analytics`, { params }).then((r) => r.data);
